import EditIcon from "@/assets/icons/lead-page/edit-icon";
import { useTelephoneContext } from "@/modules/lead-page/new/hooks/telephone-context.hook";
import useTelephoneConfig from "@/modules/lead-page/new/hooks/telephone-config.hook";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import CopyButton from "@/modules/common/components/ui/copy-button";
import WhatsappIcon from "@/assets/icons/lead-page/whatsapp-icon";
import { handleContactWhatsapp } from "@/modules/common/utils";

const TelephoneDisplay = () => {
  const theme = useTheme();

  const { telephone } = useTelephoneContext();
  const { primaryTelephone, remainingNumbersCount, hasMoreThanOneTelephone } =
    useTelephoneConfig();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: theme.nawy.spacing.xxxs,
        position: "relative",
        width: "100%",
      }}
      onClick={() => telephone.setEditTelephoneModalOpen(true)}
    >
      <Box
        sx={{
          display: "flex",
          gap: theme.nawy.spacing.xs,
          alignItems: "center",
          cursor: "pointer",
          justifyContent: "space-between",
          width: "100%",
          "&:hover .edit-icon": { opacity: 1 },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            gap: theme.nawy.spacing.xs,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: theme.nawy.spacing.xs,
              minWidth: 0,
              flexShrink: 1,
            }}
          >
            <Typography
              sx={{
                ...theme.nawy.typography.english.variants.body.md.regular,
                color:
                  primaryTelephone?.telephone === "Not set" ||
                  !primaryTelephone?.telephone
                    ? theme.nawy.colors.semantic.text.tertiary
                    : theme.nawy.colors.semantic.text.primary,
                "&:hover": { textDecoration: "underline" },
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {primaryTelephone ? primaryTelephone.telephone : "Not set"}
            </Typography>

            {primaryTelephone?.telephone &&
              primaryTelephone.telephone !== "Not set" && (
                <Box onClick={(e) => e.stopPropagation()}>
                  <CopyButton
                    text={primaryTelephone.telephone}
                    color={theme.nawy.colors.semantic.text.accent}
                    size={15}
                  />
                </Box>
              )}

            <Box
              className="edit-icon"
              sx={{
                fontSize: 16,
                color: theme.nawy.colors.semantic.text.accent,
                opacity: { mobile: 1, tablet: 0 },
                transition: "opacity 0.2s ease-in-out",
                ml: 0.5,
                flexShrink: 0,
              }}
            >
              <EditIcon />
            </Box>
          </Box>
        </Box>

        <IconButton
          sx={{
            width: "30px",
            height: "30px",
          }}
          onClick={(e) => {
            e.stopPropagation();
            handleContactWhatsapp(primaryTelephone?.telephone);
          }}
        >
          <WhatsappIcon />
        </IconButton>
      </Box>

      {hasMoreThanOneTelephone && (
        <Typography
          sx={{
            whiteSpace: "nowrap",
            color: theme.nawy.colors.semantic.text.accent,
            ...theme.nawy.typography.english.variants.body.md.regular,
            textDecoration: "none",
            "&:hover": { textDecoration: "underline" },
            cursor: "pointer",
          }}
        >
          + {remainingNumbersCount} more
        </Typography>
      )}
    </Box>
  );
};

export default TelephoneDisplay;
